import * as React from "react";

function SvgFlatFieldCorrection(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.594 0h-.532v3.188H0v.53h1.063V8.5H0v.531h1.063v4.781H0v.532h1.063v4.781H0v.531h1.063v4.782H0v.53h1.063v4.782H0v.531h1.063V34h.53v-3.719h4.782V34h.531v-3.719h4.782V34h.53v-3.719H17V34h.531v-3.719h4.782V34h.53v-3.719h4.782V34h.531v-3.719h4.782V34h.53v-3.719H34v-.531h-.531v-4.781H34v-.532h-.531v-4.78H34v-.532h-.531v-4.781H34v-.531h-.531V9.03H34V8.5h-.531V3.719H34v-.531h-.531V0h-.532v3.188h-4.78V0h-.532v3.188h-4.781V0h-.532v3.188h-4.78V0H17v3.188h-4.781V0h-.531v3.188H6.905V0h-.531v3.188H1.594V0zm31.343 3.719h-4.78V8.5h4.78V3.719zm0 5.312h-4.78v4.781h4.78v-4.78zm0 5.313h-4.78v4.781h4.78v-4.781zm0 5.312h-4.78v4.782h4.78v-4.782zm0 5.313h-4.78v4.781h4.78v-4.781zm-5.312 0v4.781h-4.781v-4.781h4.781zm0-5.313v4.782h-4.781v-4.782h4.781zm0-5.312v4.781h-4.781v-4.781h4.781zm0-5.313v4.781h-4.781v-4.78h4.781zm0-5.312V8.5h-4.781V3.719h4.781zm-5.313 0h-4.78V8.5h4.78V3.719zm0 5.312h-4.78v4.781h4.78v-4.78zm0 10.625h-4.78v4.782h4.78v-4.782zm0 5.313h-4.78v4.781h4.78v-4.781zm-5.312 0v4.781h-4.781v-4.781H17zm0-5.313v4.782h-4.781v-4.782H17zm0-5.312v4.781h-4.781v-4.781H17zm0-5.313v4.781h-4.781v-4.78H17zm0-5.312V8.5h-4.781V3.719H17zm-5.313 0h-4.78V8.5h4.78V3.719zm0 5.312h-4.78v4.781h4.78v-4.78zm0 5.313h-4.78v4.781h4.78v-4.781zm0 5.312h-4.78v4.782h4.78v-4.782zm0 5.313h-4.78v4.781h4.78v-4.781zm-5.312 0v4.781H1.594v-4.781h4.781zm0-5.313v4.782H1.594v-4.782h4.781zm0-.531v-4.781H1.594v4.781h4.781zm0-10.094v4.781H1.594v-4.78h4.781zm0-5.312V8.5H1.594V3.719h4.781z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgFlatFieldCorrection;
